import { useEffect, useState } from "react";
import Breadcrumb from "../../../../components/BreadCrumb";
import { useLocation } from "react-router";
import AutoDriverIcon from "../../../../assets/icons/manage_auto-driver_icon.svg";
import IntegrationServicesCard from "../../../../components/commons/IntegrationServicesCard";

const Index = () => {
  const [cardsData, setCardData] = useState([]);
  const location = useLocation();
  const rowData = location.state;
  const secondaryPaths = [
    {
      name: "Customer",
      url: `/dashboard/customers`,
    },
    {
      name: rowData?.companyName || rowData?.email,
      url: "",
    },
  ];
  useEffect(() => {
    if (rowData) {
      setCardData([
        {
          heading: "Auto Driver Events",
          description:
            "Defining auto event for transparent business transactions",
          url: `/dashboard/customer/${rowData.id}/manage/auto-driver`,
          Icon: <img src={AutoDriverIcon} alt="AutoDriverIcon" />,
          stateData: { ...rowData },
        },
      ]);
    }
  }, [rowData]);
  return (
    <section>
      <div className="mt-8 ml-6">
        <Breadcrumb paths={secondaryPaths} secondary={true} />
      </div>
      <div className="mt-16 integrationServicesCard-main-section">
        {cardsData.map((data, index) => (
          <IntegrationServicesCard
            key={index}
            data={data}
            airportCardStatus={{}}
          />
        ))}
      </div>
    </section>
  );
};

export default Index;
